module.exports = __webpack_public_path__ + "2X-features-bg-2.png?b6c5331d3035ba85f3d69f3032ef1121";